import {
    Avatar,
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Image,
    Input,
    message,
    Radio,
    Row,
    Typography,
    Upload,
} from 'antd'
import React, { useEffect, useState } from 'react'
import { UploadImageIcon } from '../../../assets/icons'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'
import {
    candidateById,
    candidateEdit,
    setCandidateId,
    setCandidateResumeUrl,
} from '../store/candidate.slice'
import { uploadResume, uploadResumeS3Url } from '../service/candidate.service'
import ApiSelect from '../../../components/api-select/api-select'
import { MASTER_DATA_FIELD } from '../../../constants/masterData'
import DropDownMultiple from '../../../components/dropDownMultiple'
import { changeModel, masterDataAddDropDown, masterDataDropDownList, profileState } from '../../profile/profile.slice'
import { loginState } from '../../login/login.slice'

const { TextArea } = Input

const OverviewDetails = ({
    fileURL,
    name = 'meet',
    currantData,
    activeTab,
    status
}) => {
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const {
        formButtonType,
        modelType,
        masterDataDropDown,
        isNext
    } = useSelector(profileState)
    const { candidateId, cnadidateResusmeUrl, resumeFile } = useSelector((state) => state.candidateSlice)

    const [previewImage, setPreviewImage] = useState(null)
    const [selectedProfileImage, setSelectedProfileImage] = useState(null)
    const [searchValue, setSearchValue] = useState('')
    const [page, setPage] = useState(0);
    const [loadingStatus, setLoadingStatus] = useState("loading");
    const { userProfile } = useSelector(loginState)
    const isReadOnly = status === "convertToUser";
    const fetchOptions = async (search = "", pageNumber = 1, model) => {
        setLoadingStatus("loading");
        setSearchValue(search);

        try {
            dispatch(changeModel(model))
            const result = await dispatch(
                masterDataDropDownList({
                    search: search,
                    id: model,
                    skip: pageNumber
                })
            ).unwrap(); // ⬅️ Get the actual payload

            const newData = Array.isArray(result?.data) ? result.data : [];


            setPage(pageNumber + 1);
            setLoadingStatus(newData.length === 0 ? "noData" : "loaded");
        } catch (error) {
            console.error("Dropdown fetch failed", error);
            setLoadingStatus("noData");
        }
    };
    async function addMasterData() {
        const result = await dispatch(
            masterDataAddDropDown({
                addData: {
                    type: 'manual',
                    data: {
                        name: searchValue,
                        logo:
                            modelType === 'tools'
                                ? 'https://pms-bucket123.s3.amazonaws.com/Layer_1_1689237094.svg'
                                : modelType === 'institute'
                                    ? 'https://pms-bucket123.s3.amazonaws.com/Group 35301_1689226177.svg'
                                    : '',
                        createdBy: userProfile?._id,
                    },
                },
                model: modelType,
            })
        )
        const data = result?.payload?.data

        if (data) {
            const { success, message: errorMessage } = data
            if (success) {
                dispatch(
                    masterDataDropDownList({
                        search: searchValue,
                        id: modelType,
                    })
                )
            } else {
                if (errorMessage) {
                    message.error(errorMessage)
                } else {
                    message.error('Something went wrong, try again later.')
                }
            }
        }
    }

    const resetPage = () => {
        setPage(1);
    };
    useEffect(() => {
        if (currantData) {
            form.setFieldsValue({
                name: currantData.fullName || '',
                email: currantData.personalEmail || '',
                phone: currantData?.primaryContactNumber?.startsWith("91") ? currantData.primaryContactNumber : `"91"${currantData.primaryContactNumber}` || '',
                birthDate: currantData.dateOfBirth
                    ? dayjs(currantData.dateOfBirth)
                    : null,
                gender: currantData.gender || '',
                maritalStatus: currantData.maritalStatus || 'single',
                address: currantData.address || '',
                country: currantData.country || '',
                state: currantData.state || '',
                city: currantData.city || '',
                summary: currantData.summary || '',
                totalExperience: currantData.totalExperience || "",
                designation: currantData?.designation ? {
                    label: currantData?.designation?.name,
                    value: currantData?.designation?._id,
                } : null,

            })
            setPreviewImage(currantData?.profilePicture || "")
        }
    }, [currantData])

    useEffect(() => {
        if (currantData?.resumeUrl) {
            dispatch(setCandidateResumeUrl(currantData.resumeUrl))
        }
    }, [currantData?.resumeUrl])

    const handleUploadProfileImage = async (file) => {
        try {
            const payload = {
                data: [{
                    filename: file.name,
                    contentType: file.type,
                }]
            }

            const { data } = await uploadResume(payload)

            if (data.success && data.data.length > 0) {
                const uploadMeta = data.data[0]

                const response = await uploadResumeS3Url(
                    file,
                    uploadMeta.uploadUrl,
                    uploadMeta.publicLink,
                    uploadMeta.name
                )

                if (response.ok) {
                    return uploadMeta.publicLink
                } else {
                    console.error('Upload failed:', await response.text())
                    return null
                }
            }

            return null
        } catch (error) {
            console.error('Error uploading profile image:', error)
            return null
        }
    }
    const onFinish = async (values) => {
        const extractValue = (input) => {
            if (Array.isArray(input)) {
                return input.map(item => item?.value || item)
            } else if (input && typeof input === 'object') {
                return input.value || input
            }
            return input
        }

        let profileImageUrl = null;
        if (selectedProfileImage) {
            profileImageUrl = await handleUploadProfileImage(selectedProfileImage);
        }
        let payload = {}
        payload = {
            fullName: values.name,
            personalEmail: values.email,
            primaryContactNumber: values.phone,
            dateOfBirth: values.birthDate ? values.birthDate.valueOf() : null,
            gender: values.gender,
            maritalStatus: values.maritalStatus,
            address: values.address,
            country: values.country,
            state: values.state,
            city: values.city,
            summary: values.summary,
            profilePicture: profileImageUrl,
            totalExperience: values.totalExperience,
            designation: extractValue(values?.designation),
            primaryContactNumberCountryCode: "+91",
            primaryContactNumberCountryFlag: "IN",
            candidateId,
        }
        if (candidateId == null) {
            payload = {
                ...payload,
                resumeUrl: cnadidateResusmeUrl,
                fileType: resumeFile?.type,
                fileName: resumeFile?.name
            }
        }

        try {
            const { data } = await candidateEdit(
                activeTab,
                candidateId,
                payload
            )
            if (data.success) {
                message.success(candidateId == null ? ' Candidate Create Successfully' : ' Candidate updated Successfully')
                dispatch(setCandidateId(data?.data?._id))
                dispatch(
                    candidateById({ id: candidateId == null ? data?.data?._id : candidateId, activeTab })
                )
                setSelectedProfileImage(null)
            }
        } catch (error) {
            message.error(error?.response?.data?.message)
            console.error('Error editing candidate:', error)
        }
    }

    return (
        <Form layout="vertical" form={form} onFinish={onFinish}>
            <Row
                align="middle"
                justify="center"
                gutter={16}
                style={{ marginBottom: '10px' }}
            >
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Card style={{ display: "flex", justifyContent: "center" }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                            className="candidate_upload_profile"
                        >
                            <Upload

                                listType="picture-circle"
                                className="avatar-uploader-candidate-details"
                                showUploadList={false}
                                accept=".png,.jpg,.jpeg"
                                disabled={isReadOnly}
                                beforeUpload={(file) => {
                                    const isImage =
                                        file.type.startsWith('image/')
                                    if (isImage) {
                                        const imageUrl =
                                            URL.createObjectURL(file)
                                        setPreviewImage(imageUrl)
                                        setSelectedProfileImage(file)
                                    }
                                    return false // prevent auto upload
                                }}
                            >
                                {previewImage ? (
                                    <Image
                                        src={previewImage}
                                        preview={false}
                                        style={{
                                            height: '128px',
                                            width: '128px',
                                            borderRadius: '50%',
                                        }}
                                    />
                                ) : fileURL?.length > 0 ? (
                                    <Image
                                        src={fileURL[0]}
                                        preview={false}
                                        style={{
                                            height: '128px',
                                            width: '128px',
                                            borderRadius: '50%',
                                        }}
                                    />
                                ) : (
                                    <Avatar size={128}>
                                        {currantData?.fullName
                                            ? currantData?.fullName.trim()[0].toUpperCase()
                                            : name?.trim()[0]?.toUpperCase() || ''}
                                    </Avatar>
                                )}

                                <div className="hoverLayer">
                                    <div className="hoverShow">
                                        <UploadImageIcon />
                                        <div
                                            style={{
                                                marginTop: 8,
                                                color: '#fff',
                                            }}
                                        >
                                            Update Profile
                                        </div>
                                    </div>
                                </div>
                            </Upload>
                        </div>
                    </Card>
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="Name"
                        name="name"
                        style={{ marginTop: '10px' }}
                        rules={[
                            { required: true, message: 'Name is required' },
                        ]}
                    >
                        <Input placeholder="Full Name" size="large" disabled={isReadOnly} />
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"

                        style={{ marginTop: '10px' }}
                        rules={[
                            { required: true, message: 'Email is required' },
                            { type: 'email', message: 'Enter a valid email' },
                        ]}
                    >
                        <Input placeholder="Email" size="large" disabled={isReadOnly} />
                    </Form.Item>
                    <Form.Item
                        label="Phone Number"
                        name="phone"
                        style={{ marginTop: '10px' }}
                        rules={[
                            { required: true, message: 'Phone number is required' },
                            {
                                validator: (_, value) => {
                                    const digitsOnly = value?.replace(/\D/g, ''); // remove + and non-digits
                                    const phoneWithoutCountryCode = digitsOnly.slice(2); // remove '91'
                                    return phoneWithoutCountryCode.length === 10
                                        ? Promise.resolve()
                                        : Promise.reject('Enter a valid 10-digit phone number');
                                },
                            },
                        ]}
                    >
                        <PhoneInput
                            inputStyle={{ width: '100%' }}
                            specialLabel=""
                            country="in"
                            onlyCountries={['in']}
                            disabled={isReadOnly}
                            disableDropdown={true}
                            countryCodeEditable={false}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item label="Address" name="address" rules={[
                { required: true, message: 'Address is required' },
            ]}>
                <Input placeholder="Address" size="large" disabled={isReadOnly} />
            </Form.Item>
            <Row gutter={16} style={{ marginTop: '10px' }}>
                <Col span={12}>
                    <Form.Item label="Country" name="country" rules={[
                        { required: true, message: 'Country is required' },
                    ]}>
                        <Input placeholder="Country" size="large" disabled={isReadOnly} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="State" name="state" rules={[
                        { required: true, message: 'State is required' },
                    ]}>
                        <Input placeholder="State" size="large" disabled={isReadOnly} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16} style={{ marginTop: '10px' }}>
                <Col span={12}>
                    <Form.Item label="City" name="city" rules={[
                        { required: true, message: 'City is required' },
                    ]}>
                        <Input placeholder="City" size="large" disabled={isReadOnly} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Birth Date" name="birthDate" rules={[
                        { required: true, message: 'Birth Date is required' },
                    ]}>
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="Date of Birth"
                            size="large"
                            disabled={isReadOnly}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16} style={{ marginTop: '10px' }}>

                <Col span={12}>
                    <Form.Item
                        label="Total Experience"
                        name="totalExperience"
                        rules={[
                            { required: true, message: 'Total Experience is required' },
                        ]}
                    >
                        <Input
                            placeholder="Total Experience"
                            size="large"
                            disabled={isReadOnly}
                            type="text"
                            inputMode="decimal" // mobile shows number keyboard with dot
                            onKeyPress={(e) => {
                                // Allow digits and one "."
                                const key = e.key;
                                const value = e.currentTarget.value;

                                const isDigit = /[0-9]/.test(key);
                                const isDot = key === '.';
                                const alreadyHasDot = value.includes('.');

                                if (!isDigit && !(isDot && !alreadyHasDot)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </Form.Item>
                </Col>


                <Col span={12}>
                    <ApiSelect
                        label="Designation"
                        name={MASTER_DATA_FIELD.designation}
                        disabled={isReadOnly}
                        rules={
                            formButtonType !== 'draftButtonLoading'
                                ? [{ required: true, message: 'Please Select Field of designation' }]
                                : []
                        }
                        placeholder="Designation"
                        onClick={() => {
                            resetPage();
                            fetchOptions("", 0, MASTER_DATA_FIELD.designation);
                        }}
                        onSearch={(value) => {
                            resetPage();
                            fetchOptions(value, 0, MASTER_DATA_FIELD.designation);
                        }}
                        onScrollBottom={() => {
                            fetchOptions(searchValue, page, MASTER_DATA_FIELD.designation);
                        }}
                        dropdownRender={(menu, handleScroll) => (
                            <DropDownMultiple
                                handleScroll={handleScroll}
                                menu={menu}
                                searchValue={searchValue}
                                name={
                                    MASTER_DATA_FIELD.designation
                                }
                                addMasterData={() =>
                                    addMasterData()
                                }
                            />
                        )}
                        options={masterDataDropDown?.designation}
                        dropdownStatus={loadingStatus}
                        isNext={isNext}
                    />
                </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: '10px' }}>
                <Col span={12}>
                    <Form.Item label="Marital Status" name="maritalStatus" rules={[
                        { required: true, message: 'Marital Status is required' },
                    ]}>
                        <Radio.Group
                            disabled={isReadOnly}
                            options={[
                                { label: 'Single', value: 'single' },
                                { label: 'Married', value: 'married' },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Gender" name="gender" rules={[
                        { required: true, message: 'Gender is required' },
                    ]}>
                        <Radio.Group
                            disabled={isReadOnly}
                            options={[
                                { label: 'Male', value: 'male' },
                                { label: 'Female', value: 'female' },
                            ]}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                label="Summary"
                name="summary"
                style={{ marginTop: '10px' }}
                rules={[
                    { required: true, message: 'Summary is required' },
                ]}
            >
                <TextArea rows={6} placeholder="Summary" disabled={isReadOnly} />
            </Form.Item>

            <Form.Item style={{ textAlign: 'right', marginTop: '15px' }}>
                {!isReadOnly && <Button htmlType="submit">Submit</Button>}
            </Form.Item>
        </Form>
    )
}

export default OverviewDetails
